import { render, staticRenderFns } from "./ColorCardRetouching.vue?vue&type=template&id=7af4aaaa&scoped=true"
import script from "./ColorCardRetouching.vue?vue&type=script&lang=js"
export * from "./ColorCardRetouching.vue?vue&type=script&lang=js"
import style0 from "./ColorCardRetouching.vue?vue&type=style&index=0&id=7af4aaaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4aaaa",
  null
  
)

export default component.exports